<template>
  <div class="wrapper">
    <div class="content">
      <div class="container">
        <div>
          鉴于甲方拥有专业的平台优势与资源，能够高效、智能的对
          乙方的货品进行管理。乙方愿意入驻甲方平台，并使用甲方
          提供的信息，技术以及服务。
        </div>
        <div>
          双方在自愿、平等、公平及诚实信用原则的基础上，经友好
          协商达成如下条款以资共同遵守：乙方申请成为甲方平台入
          驻供应商，须持续满足以下条件：
        </div>
        <div>
          乙方已依照中华人民共和国相关法规法律注册，并领取合法
          有效的营业执照及其他经营许可；
        </div>
        <div>乙方经营、销售的商品来源合法，资质齐全；</div>
        <div>乙方统一按照本协议及甲方平台相关规则的规定 / 要求执行。</div>
        <div>
          乙方须向甲方提交资质、资格证明文件或其他相关证明，包括
          但不限于营业执照、税务登记证、授权委托书、商标注册证质
          检报告、报关单，检验检疫证书等。
        </div>
        <div>
          乙方对其提交的证明文件或其他相应证明的真实性、合法性、
          准确性、有效性承担全部法律责任，若因乙方提交虚假、过期
          文件或未及时更新或通知证明文件导致纠纷或被相关国家机关
          处罚的，由乙方独立承担全部法律责任，如因此造成甲方损失
          的，乙方应予以赔偿(包括 直接损失和间接损失)
        </div>
      </div>
      <div class="documentName">
        文档名称：
        <div>深圳金箱科技平台入驻协议</div>
      </div>
      <div class="updateDate">版本更新日期：2022-8-26</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "GmcsWebH5Serviceagreement",

  data() {
    return {};
  },

  mounted() {},

  methods: {},
};
</script>

<style lang="less" scoped>
@import "./introduction.less";
</style>
